import './style.css'
import './js/components/SamtHeader.js'
import './js/components/SamtFooter.js'
import './js/components/SamtHero.js'
import './js/components/SamtPartners.js'
import './js/components/SamtNews.js'
import './js/components/SamtBackToTop.js'
import { initCnFontFaces } from './js/util/fontFaces.js'
import {
  initSlideSwiper,
  initFullSlideSwiper,
  initHomeMLMSwiper
} from './js/swiper-init.js'
import { initPartnersShowcase } from './js/partners.js'
import { initGlobalScrollReveal } from './js/util/scrollReveal.js'

import { initHomeI18n } from './js/pages/home/index.js'
import { getLang, getUrlLang } from './js/util/i18n.js'

const HOME_SEO = {
  en: {
    htmlLang: 'en',
    pageUrl: 'https://www.samtc.com/',
    title: 'SAMT',
    description:
      'SAMT team had the career background of the steel metallurgy company, and profession on heat treatment and surface engineering of metal materials. We have the vision to develop SAMT as the system supplier who independently own the core technology of materials and metallurgy, and keep the world-advanced leading position by the consistent innovation.',
    keywords:
      'SAMT,samt,samtc,Shaoxing SAMT,Shanghai SAMT,heat treatment,vacuum furnace,vacuum cleaning machine',
    author: 'SAMT',
    ogLocale: 'en_US',
    ogTitle: 'SAMT',
    ogDescription:
      'One excellence team consisting of senior metallurgist sponsored to create the consulting business for the application of materials and metallurgy in Shanghai at the spring of year 2009.',
    orgDescription:
      'SAMT team had the career background of the steel metallurgy company, and profession on heat treatment and surface engineering of metal materials. We have the vision to develop SAMT as the system supplier who independently own the core technology of materials and metallurgy, and keep the world-advanced leading position by the consistent innovation.'
  },
  zh: {
    htmlLang: 'zh-CN',
    pageUrl: 'https://www.samtc.com/?lang=zh-CN',
    title: 'SAMT 先越',
    description:
      '先越团队成员拥有钢铁冶金企业从业背景，以及金属材料热处理和表面工程专业经验。我们的愿景是将先越发展成为具备材料与冶金关键技术能力的系统供应商，并以持续创新保持技术研发的前瞻性。',
    keywords:
      '先越,SAMT,samt,samtc,先越材料,绍兴先越,上海先越,热处理,真空炉,真空清洗机',
    author: 'SAMT 先越',
    ogLocale: 'zh_CN',
    ogTitle: 'SAMT 先越',
    ogDescription:
      '一个由冶金领域资深成员组成的专业团队,于2009年春天在上海创建了材料和冶金应用咨询业务。',
    orgDescription:
      '先越团队成员拥有钢铁冶金企业从业背景，以及金属材料热处理和表面工程专业经验。我们的愿景是将先越发展成为具备材料与冶金关键技术能力的系统供应商，并以持续创新保持技术研发的前瞻性。'
  }
}

const updateTagContent = (selector, attribute, value) => {
  const element = document.querySelector(selector)
  if (!element || !value) return
  element.setAttribute(attribute, value)
}

const initHomeSeoByLang = () => {
  const lang = getLang()
  const urlLang = getUrlLang()
  const seo = HOME_SEO[lang] || HOME_SEO.en

  document.documentElement.setAttribute('lang', seo.htmlLang)
  document.title = seo.title

  updateTagContent('#canonical-link', 'href', seo.pageUrl)
  updateTagContent('#alternate-link-en', 'href', 'https://www.samtc.com/')
  updateTagContent(
    '#alternate-link-zh',
    'href',
    'https://www.samtc.com/?lang=zh-CN'
  )
  updateTagContent(
    '#alternate-link-x-default',
    'href',
    'https://www.samtc.com/'
  )
  updateTagContent('#meta-description', 'content', seo.description)
  updateTagContent('#meta-keywords', 'content', seo.keywords)
  updateTagContent('#meta-author', 'content', seo.author)
  updateTagContent('#meta-og-locale', 'content', seo.ogLocale)
  updateTagContent('#meta-og-url', 'content', seo.pageUrl)
  updateTagContent('#meta-og-title', 'content', seo.ogTitle)
  updateTagContent('#meta-og-description', 'content', seo.ogDescription)

  const jsonLdScript = document.getElementById('org-jsonld')
  if (jsonLdScript) {
    const orgJsonLd = {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: seo.title,
      url: seo.pageUrl,
      description: seo.orgDescription,
      logo: 'https://www.samtc.com/images/logo.png',
      inLanguage: urlLang
    }
    jsonLdScript.textContent = JSON.stringify(orgJsonLd)
  }
}

initCnFontFaces()

document.addEventListener('DOMContentLoaded', function () {
  initHomeSeoByLang()
  initHomeI18n()
  initSlideSwiper()
  initFullSlideSwiper()
  initHomeMLMSwiper()
  initPartnersShowcase()
  initGlobalScrollReveal()
})
